module.exports = __webpack_public_path__ + "img/burkina-faso.c687a881.svg";